import React from 'react';

import Presenter from 'components/presenters/challenge/ChallengeDetailDescription';

export default function ChallengeDetailDescription({
  descriptions
}) {
  
  return (
    descriptions?.map((description, index) => {
      return (
        <Presenter key={`detail_description_${index}`} description={description}/>
      )
    })
    
  )
}